module.exports = __webpack_public_path__ + "img/testimonial-bg.jpg";